// Áudio da RECARGA PREMIADA — mesmo padrão dos outros eventos (OIL/GB): mudo geral, sons do jogo e música
// com volume, persistidos no navegador. Música = playlist das 2 trilhas enviadas pelo dono, alternando.
const readVol = (key, def) => {
  const v = parseFloat(localStorage.getItem(key));
  return Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : def;
};

export const getAudioConfig = () => ({
  muted: localStorage.getItem('rp_muted') === 'on',
  sfxOn: localStorage.getItem('rp_sfx') !== 'off',
  sfxVol: readVol('rp_sfx_vol', 0.8),
  musicOn: localStorage.getItem('rp_music') !== 'off',
  musicVol: readVol('rp_music_vol', 0.35),
});

const sfxEnabled = () => { const c = getAudioConfig(); return c.sfxOn && !c.muted && c.sfxVol > 0; };

// ===== música de fundo (playlist) =====
const PLAYLIST = ['/rp/music1.mp3', '/rp/music2.mp3'];
let el = null;
let track = 0;
let wanted = false;   // página quer música tocando (fica false ao sair da página)

const tryPlay = () => {
  if (!el) return;
  const p = el.play();
  if (p && p.catch) {
    p.catch(() => {
      const retry = () => { if (wanted && el) el.play().catch(() => {}); };
      document.addEventListener('pointerdown', retry, { once: true });
    });
  }
};

export const applyAudioToMusic = () => {
  if (!el) return;
  const c = getAudioConfig();
  el.volume = c.muted ? 0 : c.musicVol;
  if (!wanted || !c.musicOn || c.muted || c.musicVol === 0) el.pause();
  else if (el.paused) tryPlay();
};

export const music = {
  start: () => {
    wanted = true;
    if (!el) {
      el = new Audio(PLAYLIST[track]);
      el.preload = 'auto';
      el.onended = () => { track = (track + 1) % PLAYLIST.length; el.src = PLAYLIST[track]; applyAudioToMusic(); };
    }
    applyAudioToMusic();
  },
  stop: () => { wanted = false; if (el) { el.pause(); } },
  duck: (on) => { if (!el) return; const c = getAudioConfig(); el.volume = c.muted ? 0 : (on ? c.musicVol * 0.15 : c.musicVol); },
};

export const setAudioConfig = (patch) => {
  if ('muted' in patch) localStorage.setItem('rp_muted', patch.muted ? 'on' : 'off');
  if ('sfxOn' in patch) localStorage.setItem('rp_sfx', patch.sfxOn ? 'on' : 'off');
  if ('sfxVol' in patch) localStorage.setItem('rp_sfx_vol', String(patch.sfxVol));
  if ('musicOn' in patch) localStorage.setItem('rp_music', patch.musicOn ? 'on' : 'off');
  if ('musicVol' in patch) localStorage.setItem('rp_music_vol', String(patch.musicVol));
  applyAudioToMusic();
  return getAudioConfig();
};

// ===== clipes gravados (respeitam "sons do jogo") =====
const clipCache = {};
export const playClip = (src, vol = 1) => {
  if (!sfxEnabled()) return;
  try {
    let a = clipCache[src];
    if (!a) { a = new Audio(src); a.preload = 'auto'; clipCache[src] = a; }
    a.currentTime = 0;
    a.volume = Math.min(1, getAudioConfig().sfxVol * vol);
    a.play().catch(() => {});
  } catch { /* sem áudio */ }
};

// ===== efeitos sintetizados (botões) =====
let ctx = null;
const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};
const tone = (ac, { freq = 440, type = 'sine', t0 = 0, dur = 0.2, vol = 0.15, slideTo = null }) => {
  const o = ac.createOscillator();
  const g = ac.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, ac.currentTime + t0);
  if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, ac.currentTime + t0 + dur);
  const v = vol * getAudioConfig().sfxVol;
  g.gain.setValueAtTime(v, ac.currentTime + t0);
  g.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + t0 + dur);
  o.connect(g).connect(ac.destination);
  o.start(ac.currentTime + t0);
  o.stop(ac.currentTime + t0 + dur + 0.05);
};
const safe = (fn) => { if (!sfxEnabled()) return; try { fn(getCtx()); } catch { /* noop */ } };

export const sfx = {
  // clique genérico de botão
  click: () => safe((ac) => tone(ac, { freq: 880, type: 'triangle', dur: 0.07, vol: 0.12 })),
  // troca de aba
  tab: () => safe((ac) => { tone(ac, { freq: 660, type: 'triangle', dur: 0.06, vol: 0.1 }); tone(ac, { freq: 990, type: 'triangle', t0: 0.06, dur: 0.08, vol: 0.1 }); }),
  // abrir baú: "clack" + brilho subindo
  open: () => safe((ac) => { tone(ac, { freq: 220, type: 'square', dur: 0.09, vol: 0.12 }); tone(ac, { freq: 520, type: 'sine', t0: 0.08, dur: 0.5, vol: 0.12, slideTo: 1560 }); }),
  // receber na live: arpejo
  claim: () => safe((ac) => [523, 659, 784, 1047].forEach((f, i) => tone(ac, { freq: f, type: 'triangle', t0: i * 0.07, dur: 0.18, vol: 0.12 }))),
  // aviso / erro
  fail: () => safe((ac) => { tone(ac, { freq: 260, type: 'square', dur: 0.15, vol: 0.08 }); tone(ac, { freq: 180, type: 'square', t0: 0.16, dur: 0.3, vol: 0.08 }); }),
  // fechar / voltar
  close: () => safe((ac) => tone(ac, { freq: 520, type: 'triangle', dur: 0.09, vol: 0.1, slideTo: 300 })),
};
